import Dashboard from '../../views/Dashboard';
import ReportingPage from '../../views/Reporting';
import MesCommandes from '../../views/MesCommandes';
import Ressources from '../../views/Ressources';
import Pedagogies from '../../views/Pedagogies';
import Quizzes from '../../views/Quizzes';
import MesNotes from '../../views/MesNotes';
import PanierView from '../../views/Panier';
import MaClasse from '../../views/MaClasse';
import pages from '../pages';
import { Route } from '../routes';
import { Panier } from '../../components/organisms/Panier';
import { Documents } from '../../views/Documents';
import Formations from '../../views/Formations';
import { FormationRessources } from '../../views/Formations/FormationRessources';
import { PedagogieRessources } from '../../views/Pedagogies/PedagogieRessources';
import { RessourcesChallengesRessources } from '../../views/Ressources/RessourcesChallengeRessources';
import PedagogicalChallenges from 'views/PedagogicalChallenges';
import { NGO } from '../../views/NGO';
import { NgoChoice } from '../../views/NGO/NgoChoicePage';

export const pageRoutes: Route[] = [
  {
    path: pages.HOME_PAGE.path,
    component: Dashboard
  },
  {
    path: pages.PANIER_PAGE.path,
    component: Panier
  },
  {
    path: pages.PRODUCTS_PAGE.path,
    component: ReportingPage
  },
  {
    path: pages.MES_COMMANDES_PAGE.path,
    component: MesCommandes
  },
  {
    path: pages.DOCUMENTS_PAGE.path,
    component: Documents
  },
  {
    path: pages.RESSOURCES_PAGE.path,
    component: Ressources
  },
  {
    path: pages.RESSOURCES_TYPE_PAGE.path,
    component: RessourcesChallengesRessources
  },
  {
    path: pages.PEDAGOGIES_PAGE.path,
    component: Pedagogies
  },
  {
    path: pages.PEDAGOGIES_TYPE_PAGE.path,
    component: PedagogieRessources
  },
  {
    path: pages.FORMATIONS_PAGE.path,
    component: Formations
  },
  {
    path: pages.FORMATIONS_TYPE_PAGE.path,
    component: FormationRessources
  },
  {
    path: pages.QUIZ_PAGE.path,
    component: Quizzes
  },
  {
    path: pages.NOTE_PAGE.path,
    component: MesNotes
  },
  {
    path: pages.HOME_PAGE.path,
    component: PanierView
  },
  {
    path: pages.CLASSE_SETTINGS_PAGE.path,
    component: MaClasse
  },
  {
    path: pages.NGO.path,
    component: NGO
  },
  {
    path: pages.NGO_CHOICE_PAGE.path,
    component: NgoChoice
  },
  {
    path: pages.PEDAGOGICAL_CHALLENGES.path,
    component: PedagogicalChallenges
  }
];
